import * as React from 'react';

import { IDocument, IBranding } from '../../infrastructure/interfaces';
import Radio from '../Radio';

export interface IBrandingEditorFormProps {
  document: IDocument;
  brandings: IBranding[];
  onBrandChange(brand: any): void;
  className: string;
}

export default class BrandingEditorForm extends React.Component<IBrandingEditorFormProps> {

  render() {
    return (
      <div className={this.props.className}>
        {this.props.brandings.map(brand => (
          <div key={brand.id} className="rowStepTwo">
            <Radio
              checked={(this.props.document.branding && this.props.document.branding.id === brand.id)!}
              onChange={() => this.props.onBrandChange(brand)}
            >
              <img alt={brand.title} src={brand.image} />
            </Radio>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/BrandingEditorForm.tsx